import { PageContainer } from '@shared';

import { useTranslations } from '@/i18n/client';

export function NotFoundPage() {
  const t = useTranslations('errors.pageNotFound');

  return (
    <PageContainer>
      <h1 className="md-page__title">{t('title')}</h1>
      <p className="md-page__lead">{t('description')}</p>
    </PageContainer>
  );
}
